var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-x grid-margin-x align-center course-desc"},[_c('div',{staticClass:"small-12 medium-10 large-8"},[_c('h2',[_vm._v(_vm._s(this.dctxt('information_about_course')))]),_vm._v(" "),_c('p',{ref:"courseDesc",class:{
				'course-desc-accordion': _vm.hasAccordion,
				expanded: _vm.accordionExpanded,
			}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.hasAccordion)?_c('a',{class:[
				'dc-button',
				'dc-button--has-icon',
				'dc-button--color-orange',
				'dc-toggle__button',
				{
					'dc-toggle__button--active': _vm.accordionExpanded,
				} ],attrs:{"href":"#","role":"button","rel":"nofollow","aria-label":"Expand accordion","aria-expanded":_vm.accordionExpanded},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleAccordion.apply(null, arguments)}}},[_c('span',{staticClass:"icon icon-arrow-down"})]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }